import React from "react";
import styles from "./Nav.module.css";
import {
  Box,
  Button,
  Flex,
  IconButton,
  Text,
  useColorMode,
  Hide,
  Show,
} from "@chakra-ui/react";
import { FaSun, FaMoon } from "react-icons/fa";
import { Link } from "react-scroll";
import Sidebar from "./Sidebar";
import Resume from "../Home/Image/Vivek_Rana_Resume.pdf";

const Navbar = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  const isDark = colorMode === "dark";
  const handleDownload = () => {
    window.open(
      "https://drive.google.com/file/d/1gbDiyd9Wkv9zEulCPvp3LuH8BW1Lz74C/view?usp=share_link",
      "_blank"
    );
  };
  return (
    <>
      <Box id="nav-menu" className={styles.main}>
        <Box className={styles.left}>
          <Box className={styles.name}>
            <Flex>
              <span>
                <Link to="Navbar" spy={true} smooth={true}>
                  <Text cursor="pointer" color={"#f4e16a"}>
                    VIV
                  </Text>
                </Link>
              </span>
              <span>
                <Link to="Navbar" spy={true} smooth={true}>
                  <Text cursor="pointer" color={"#075985 "}>
                    EK
                  </Text>
                </Link>
              </span>
            </Flex>
          </Box>
        </Box>

        <Box className={styles.right}>
          <Hide below="md">
            <Box className={styles.list}>
              <ul>
                <li className="nav-link.home">
                  <Link
                    activeClass="active"
                    to="Navbar"
                    offset={-55}
                    spy={true}
                    smooth={true}
                  >
                    <Text fontWeight={"medium"} color="white">
                      HOME
                    </Text>
                  </Link>
                </li>
                <li className="nav-link.about">
                  <Link to="tech-stack" spy={true} smooth={true} offset={-50}>
                    <Text fontWeight={"medium"} color="white">
                      TECH-STACK{" "}
                    </Text>
                  </Link>
                </li>
                <li className="nav-link.skills">
                  <Link to="skills" spy={true} offset={-50} smooth={true}>
                    <Text fontWeight={"medium"} color="white">
                      {" "}
                      SKILLS{" "}
                    </Text>
                  </Link>
                </li>
                <li className="nav-link.projects">
                  <Link to="projects" offset={-175} spy={true} smooth={true}>
                    <Text fontWeight={"medium"} color="white">
                      PROJECT-BLOGS{" "}
                    </Text>
                  </Link>
                </li>
              </ul>
            </Box>
          </Hide>

          <Hide below="sm">
            <Link className="nav-link.contact" to="contact" spy={true} smooth={true}>
              <Button
                colorScheme={"#67dcfa"}
                color="white"
                size={"sm"}
                mt={2}
                outline="none"
                _focus={{ outline: "none" }}
              >
                <Text color="white">CONTACT ME </Text>{" "}
              </Button>
            </Link>
          </Hide>
          <Hide below="sm">
            <a
              onClick={handleDownload}
              href={Resume}
              download
              rel="noreferrer"
              style={{ textDecoration: "none" }}
              className="nav-link-resume"
            >
              <Button
              id="resume-button-1"
                colorScheme={"#67dcfa"}
                size={"sm"}
                mt={2}
                outline="none"
                color="white"
                _focus={{ outline: "none" }}
              >
                {" "}
                <Text color="white">RESUME </Text>{" "}
              </Button>
            </a>
          </Hide>

          <IconButton
            colorScheme={"#67dcfa"}
            _focus={{ outline: "none" }}
            size="sm"
            m={2}
            onClick={toggleColorMode}
            icon={isDark ? <FaSun /> : <FaMoon />}
          />

          {/* ----------------------------------------------------------------------------------------- */}

          <Show below="md">
            <Sidebar />
          </Show>
        </Box>
      </Box>
    </>
  );
};

export default Navbar;
